import Cookies from 'js-cookie'

var popupNewsletterShow = Cookies.get('popupNewsletter');

function popup() {
    $.fancybox.open({
        src: '#newsletter-popup',
        type: 'inline',
        opts: {
            touch: false,
            btnTpl: {
                smallBtn: `
                    <button data-fancybox-close class="fancybox-button fancybox-close-small">
                        <i class="icon-close icon-m"></i>
                    </button>
                `
            },
            beforeLoad: function () {
                $(_fixedElements).each(function (index, el) {
                    $(el).addClass('compensate-for-scrollbar');
                })
            },
            afterClose: function () {
                $(_fixedElements).each(function (index, el) {
                    $(el).removeClass('compensate-for-scrollbar');
                })

                Cookies.set('popupNewsletter', false, {
                    expires: 30
                });
            }
        }
    });
}

if (!popupNewsletterShow || popupNewsletterShow == 'true') {
    Cookies.set('popupNewsletter', true);
    window.setTimeout(function () {
        popup();
    }, 20000);
}